import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListItemProps,
} from "@mui/material";
import { Link } from "react-router-dom";

interface DrawerItemProps extends ListItemProps {
  path: string;
  icon: React.ReactNode;
  text: string;
}

const DrawerItem = ({ path, icon, text, ...props }: DrawerItemProps) => {
  return (
    <ListItem style={{ padding: 0 }} {...props}>
      <ListItemButton component={Link} to={path}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={text} />
      </ListItemButton>
    </ListItem>
  );
};

export default DrawerItem;
